import ActionTypes from "../constants/action_types";

export default function clearIssue(organisationId) {
  return {
    type: ActionTypes.ISSUES_CLEAR.SUCCESS,
    organisation_id: organisationId,
  };
}
